function Doprava_d_p_I(){
    return(
        <div>
            Doprava a distribucia plynov 1
        </div>

    );
};

export default Doprava_d_p_I;